import script from "./GuidePdf.vue?vue&type=script&setup=true&lang=js"
export * from "./GuidePdf.vue?vue&type=script&setup=true&lang=js"

import "./GuidePdf.vue?vue&type=style&index=0&id=4ef32469&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef32469"]])

export default __exports__